import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=26cc1183&"
import script from "./Billboard.vue?vue&type=script&lang=js&"
export * from "./Billboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports